/*
 *  Plugin para subidas de imagenes, depende de croppie y fineuploader
 */

;(function ($, window, document, undefined) {

    var pluginName = "beUpload",
        defaults = {
            $fileInput: '.js-beUpload-file',
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;

        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.options.$fileInput = $(element).find(this.options.$fileInput);

        this.uploadUrl = this.$element.data('upload-url');

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;

        Plugin.options.$fileInput.on('change', function () {
            Plugin.readFile(this);
        });
    };


    Plugin.prototype.readFile = function (input) {
        var Plugin = this;

        if (input.files && input.files[0]) {

            var file = input.files[0];

            var fileData = new FormData();

            fileData.append('file', file);
            fileData.append('field-name', input.name);

        } else {
            alert("error");
        }

        $.ajax({
            url: window.location.origin + Plugin.uploadUrl,
            type: 'POST',
            data: fileData,
            contentType: false,
            processData: false,
            success: function (data) {
                if (data.reload) {
                    location.reload(true);
                }

                if(typeof data.html !== 'undefined') {
                    Plugin.$element.find('.js-beUpload-result').html(data.html);
                }
            },
            error: function () {
                console.error('Error al cargar la imagen')
            }
        });

    };

// A really lightweight plugin wrapper around the constructor,
// preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin(this, options));
            }
        });
    }

})(jQuery, window, document);